import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ps2exchequer',
  templateUrl: './ps2exchequer.component.html',
  styleUrls: ['./ps2exchequer.component.css']
})
export class Ps2exchequerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
